import { Grid, Link, Paper, Typography, Box, Divider } from '@mui/material'
import React from 'react'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import styled from 'styled-components'
import { Telegram } from '@mui/icons-material'

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 300,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
})

const SocialImg = styled.img`
  margin: 0.5rem;
  filter: invert(99%) sepia(0%) saturate(2854%) hue-rotate(179deg)
    brightness(80%) contrast(84%);
  &:hover {
    filter: invert(99%) sepia(0%) saturate(2854%) hue-rotate(179deg)
      brightness(120%) contrast(84%);
  }
`

const StyledLink = styled(Link)`
  color: #fffff9 !important;
  display: block !important;
  margin-top: 1rem !important;
  text-decoration: none !important;
  &:hover {
    color: #8997b1 !important;
  }
`

const Footer = () => {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Paper
          sx={{
            backgroundColor: '#2C2E3F',
            // minHeight: "20vh",
            color: '#FFFFF9',
            width: '100%',
          }}
        >
          <Box pt={2}>
            <Box
              sx={{
                maxWidth: '800px',
                justifyContent: 'space-around',
                display: { md: 'flex', xs: 'grid' },
                margin: 'auto',
                marginBottom: '2rem',
              }}
            >
              <Box>
                <Typography
                  sx={{
                    textAlign: 'center',
                    mt: 3,
                    maxWidth: 'fit-content',
                  }}
                >
                  Company
                </Typography>
                <Divider />
                <StyledLink href="#">Advertise</StyledLink>
                <StyledLink href="#">Contact Us</StyledLink>
                <StyledLink href="#">Brans Assets</StyledLink>
                <StyledLink href="#">Term Of Service</StyledLink>
              </Box>
              <Box>
                <Typography
                  sx={{
                    textAlign: 'center',
                    mt: 2,
                    maxWidth: 'fit-content',
                  }}
                >
                  Community
                </Typography>
                <Divider />
                <StyledLink href="#">Knowledge Base</StyledLink>
                <StyledLink href="#">Network Status</StyledLink>
              </Box>
              <Box>
                <Typography
                  sx={{
                    textAlign: 'center',
                    mt: 2,
                    maxWidth: 'fit-content',
                  }}
                >
                  Products
                </Typography>
                <Divider />
                <StyledLink href="#">DeXit finance</StyledLink>
                {/* <StyledLink>BlockScan</StyledLink> */}
                {/* <StyledLink>PolygonScan</StyledLink> */}
              </Box>
            </Box>
            <Grid
              container
              sx={{
                justifyContent: 'center',
                maxWidth: '800px !important',
                margin: 'auto',
                borderTop: '1px solid #383B4F',
                padding: '1rem',
              }}
              flexDirection="row"
            >
              <Link href="https://web.telegram.org/k/#@deXit_Network_official">
                <SocialImg
                  src="https://img.icons8.com/glyph-neue/0.6x/sent.png"
                  alt=""
                />
              </Link>
              <Link href="https://twitter.com/Dexitnetwork">
                <SocialImg
                  src="https://img.icons8.com/tiny-glyph/2x/twitter.png"
                  alt=""
                />
              </Link>
              <Link href="https://www.facebook.com/Dexit.network">
                <SocialImg
                  src="https://img.icons8.com/tiny-glyph/2x/facebook-new.png"
                  alt=""
                />
              </Link>
              <Link href="https://www.linkedin.com/company/dexit">
                <SocialImg
                  src="https://img.icons8.com/small/2x/linkedin.png"
                  alt=""
                />
              </Link>
              <Link href="https://www.instagram.com/dexit_network/">
                <SocialImg
                  src="https://img.icons8.com/tiny-glyph/2x/instagram-new.png"
                  alt=""
                />
              </Link>
              <Link href="https://discord.gg/Qge6EHgyzH">
                <SocialImg
                  src="https://img.icons8.com/ios-filled/0.7x/discord-logo.svg"
                  alt=""
                />
              </Link>
            </Grid>
          </Box>
        </Paper>
      </ThemeProvider>
    </>
  )
}

export default Footer
